import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBox = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.24999 5.58751L7 4.7125L8.75001 5.58751V1.49999H5.24999V5.58751ZM3.25 10.75V9.25H7V10.75H3.25ZM1.49999 13.75C1.16249 13.75 0.869781 13.626 0.621869 13.3781C0.373956 13.1302 0.25 12.8375 0.25 12.5V1.49999C0.25 1.16249 0.373956 0.869781 0.621869 0.621869C0.869781 0.373956 1.16249 0.25 1.49999 0.25H12.5C12.8375 0.25 13.1302 0.373956 13.3781 0.621869C13.626 0.869781 13.75 1.16249 13.75 1.49999V12.5C13.75 12.8375 13.626 13.1302 13.3781 13.3781C13.1302 13.626 12.8375 13.75 12.5 13.75H1.49999ZM1.49999 12.5H12.5V1.49999H10V7.61249L7 6.11249L4 7.61249V1.49999H1.49999V12.5Z",
		fill: "inherit"
	})
});
export default SvgBox;
